import React from 'react';
import { motion } from 'framer-motion';

const courses = [
  { title: "Physics Animated", class: "Classes 9-12", subject: "Physics", desc: "From motion to waves – see every law in action before you calculate." },
  { title: "Chemistry Visualized", class: "Classes 9-12", subject: "Chemistry", desc: "Atomic structure, bonding, and reactions explained as moving models." },
  { title: "Math for Exams", class: "Classes 9-12", subject: "Math", desc: "Functions, calculus, and probability with step-by-step animations." },
  { title: "CS & Programming", class: "Classes 9-12", subject: "CS", desc: "Logic, algorithms, and data structures aligned to school curricula." },
];

const CoursesSenior = () => {
  return (
    <section id="senior" className="py-20 bg-slate-950 relative overflow-hidden">
      {/* Background Decor - Silhouette */}
      <div className="absolute right-0 bottom-0 opacity-5 pointer-events-none">
        <svg width="400" height="200" viewBox="0 0 400 200">
           <path d="M0,200 L400,200 L350,100 L50,100 Z" fill="currentColor" className="text-slate-100" />
        </svg>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="mb-12">
           <div className="flex items-center gap-4 mb-2">
            <div className="h-1 w-12 bg-cyan-600 rounded-full"></div>
            <span className="text-cyan-500 font-bold uppercase tracking-widest text-sm">Senior Level</span>
          </div>
          <h2 className="text-3xl font-bold text-slate-100 mb-2">Master Concepts: Classes 9–12</h2>
          <p className="text-slate-400 max-w-2xl">High-school science and math, explained like you always wished they were. Visuals meets rigor.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {courses.map((course, idx) => (
            <motion.div 
              key={idx}
              whileHover={{ y: -5 }}
              className="bg-slate-900/80 backdrop-blur-sm p-6 rounded-xl border border-slate-800 hover:border-cyan-600/50 hover:bg-slate-900 transition-all cursor-pointer"
            >
              <div className="mb-4">
                <span className="text-xs font-semibold text-cyan-400">{course.subject}</span>
              </div>
              <h3 className="text-xl font-bold text-slate-100 mb-2">{course.title}</h3>
              <p className="text-sm text-slate-400 mb-4">{course.desc}</p>
              <div className="w-full h-px bg-slate-800 mb-4"></div>
              <div className="text-xs text-slate-500">{course.class}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoursesSenior;